






	// @ts-ignore
    import _ from './CFinish.ts'; export default _;
